import { createSlice } from '@reduxjs/toolkit'

let newState

const stakeInfoSlice = createSlice({
  name: 'stakeInfo',
  initialState: {
    isLoading: false,
    stakingCards: {},
    stakeSlots: [],
    userNFTStakingDetails: [],
    sparks: [],
    sparksAmount: 0,
    status: 'NOT_FETCHED',
  },
  reducers: {
    getStakeInfo() {},
    setStakeInfo(state, action) {
      switch (action.payload.type) {
        case 'GET_STAKEINFO_START':
          newState = {
            isLoading: true,
            status: 'FETCHING_STAKEINFO',
            ...state,
          }
          return newState
        case 'GET_STAKEINFO_SUCCESS':
          newState = {
            ...state,
            isLoading: false,
            status: 'GET_STAKEINFO_SUCCESS',
            stakeSlots: action.payload.stakeSlots,
            stakingCards: action.payload.stakingCards,
            userNFTStakingDetails: action.payload.userNFTStakingDetails,
            sparks:action.payload.sparks,
            sparksAmount: action.payload.sparksAmount,

          }
          return newState
        case 'GET_STAKEINFO_ERROR':
          newState = {
            ...state,
            isLoading: false,
            status: 'GET_STAKEINFO_ERROR',
            hasError: true,
            errorMessage: action.payload,
          }
          return newState
        default:
          return state
      }
    },
  },
})

export const { getStakeInfo, setStakeInfo } = stakeInfoSlice.actions

export default stakeInfoSlice.reducer
